<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:29:32
-->
<template>
  <mrc_ess_skeleton_loader :loading="loading">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <!-- <mrc_ess_prompt :label="this.$t('label_The_original_company') + '*'"
                            :rules="false"
                            :chips="false"
                            :errMsg="$errors('list', 'org_level_uuid', requiredRule)"
                            :disabled="disabled"
                            :obj="org_uuid"
                            v-model="list.org_level_uuid">
            </mrc_ess_prompt> -->

            <mrc_ess_autoComplete
              :label="$t('label_The_original_company') + '*'"
              :readonly="disabled"
              orgView
              v-model="list.org_level_uuid"
              :error-messages="$errors('list', 'org_level_uuid', requiredRule)"
              :prompt_name="org_uuid"
            >
            </mrc_ess_autoComplete>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- <mrc_ess_prompt :label="this.$t('label_The_original_department') + '*'"
                            :rules="false"
                            :disabled="disabled"
                            :errMsg="$errors('list', 'origin_dept_uuid', requiredRule)"
                            v-model="list.origin_dept_uuid"
                            :obj="deptuuid">
            </mrc_ess_prompt> -->
            <mrc_ess_autoComplete
              :label="$t('label_The_original_department') + '*'"
              :readonly="disabled"
              deptView
              v-model="list.origin_dept_uuid"
              :error-messages="
                $errors('list', 'origin_dept_uuid', requiredRule)
              "
              :prompt_name="deptuuid"
            >
            </mrc_ess_autoComplete>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_dictName
              :label="$t('label_changeType') + '*'"
              :rules="false"
              :chips="false"
              :disabled="disabled"
              :errMsg="$errors('list', 'change_status_uuid', requiredRule)"
              v-model="list.change_status_uuid"
              :obj="changeType"
            >
            </mrc_ess_dictName>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- -->
            <mrc_ess_datePicker
              @getTime="paramsChange"
              afterDate
              :disabled="disabled"
              :errMsg="$errors('list', 'change_effective', requiredRule)"
              :label="this.$t('label_Effective_date') + '*'"
              v-model="list.change_effective"
            ></mrc_ess_datePicker>
          </v-col>
        </v-row>
        <div>
          <div
            class="pl-6 pt-6 pr-6 mt-4 mb-6"
            v-show="list.change_status_uuid != 1"
            style="border: 2px solid rgb(238, 238, 240); border-radius: 8px"
          >
            <v-row>
              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="this.$t('label_New_company') + '*'"
                                :rules="false"
                                :obj="org_uuid"
                                :errMsg="
                    $errors('list', 'new_org_level_uuid', [
                      { rule: 'typeRequired', msg: $t('verify_Required') },
                    ])
                  "
                                :disabled="list.change_status_uuid == 1 ? true : disabled"
                                v-model="list.new_org_level_uuid">
                </mrc_ess_prompt> -->

                <mrc_ess_autoComplete
                  :label="$t('label_New_company') + '*'"
                  :readonly="list.change_status_uuid == 1 ? true : disabled"
                  orgView
                  v-model="list.new_org_level_uuid"
                  :error-messages="
                    $errors('list', 'new_org_level_uuid', [
                      { rule: 'typeRequired', msg: $t('verify_Required') },
                    ])
                  "
                  :prompt_name="org_uuid"
                >
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12" sm="6">
                <!-- <mrc_ess_prompt :label="this.$t('label_New_department') + '*'"
                                :rules="false"
                                :disabled="list.change_status_uuid == 1 ? true : disabled"
                                :errMsg="
                    $errors('list', 'new_dept_uuid', [
                      { rule: 'typeRequired', msg: $t('verify_Required') },
                    ])
                  "
                                v-model="list.new_dept_uuid"
                                :obj="newdeptuuid">
                </mrc_ess_prompt> -->
                <mrc_ess_autoComplete
                  :label="$t('label_New_department') + '*'"
                  :readonly="list.change_status_uuid == 1 ? true : disabled"
                  deptView
                  v-model="list.new_dept_uuid"
                  :error-messages="
                    $errors('list', 'new_dept_uuid', [
                      { rule: 'typeRequired', msg: $t('verify_Required') },
                    ])
                  "
                  :prompt_name="newdeptuuid"
                >
                </mrc_ess_autoComplete>
              </v-col>
              <v-col cols="12" v-if="list.change_status_uuid == 2">
                <mrc_ess_prompt
                  :label="$t('label_newDepartManager') + '*'"
                  :rules="false"
                  :errMsg="
                    $errors('list', 'dept_principal_uuid', [
                      { rule: 'typeRequired', msg: $t('verify_Required') },
                    ])
                  "
                  :disabled="list.change_status_uuid == 1 ? true : disabled"
                  v-model="list.dept_principal_uuid"
                  :obj="newsuperior"
                >
                </mrc_ess_prompt>
              </v-col>
              <!-- <v-col cols="12"
                   sm="6">
              <mrc_ess_prompt :label="$t('label_role')+'：'+$t('label_move')+'/'+$t('label_merge')+'*'"
                              :rules='false'
                              :multiple="true"
                              :disabled='disabled'
                              v-model="list.transferred_role_uuid"
                              :obj="newspica">
              </mrc_ess_prompt>
            </v-col> -->
              <v-col cols="12">
                <!-- :errMsg="$errors('list','transfer_job_post_uuid',[{rule:'typeRequired',msg:$t('verify_Required')}])" -->
                <!-- +'：'+$t('label_move')+'/'+$t('label_merge')+ -->
                <!-- <mrc_ess_prompt :label="$t('label_post')"
                                :rules="false"
                                :disabled="list.change_status_uuid == 1 ? true : disabled"
                                v-model="list.transfer_job_post_uuid"
                                :obj="newjob_post_uuid">
                </mrc_ess_prompt> -->

                <mrc_ess_autoComplete
                  :label="$t('label_post')"
                  :readonly="list.change_status_uuid == 1 ? true : disabled"
                  positionView
                  v-model="list.transfer_job_post_uuid"
                  :prompt_name="newjob_post_uuid"
                >
                </mrc_ess_autoComplete>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="12">
              <mrc_ess_multiText
                :label="this.$t('label_note')"
                noRequired
                :error-messages="$errors('list', 'remark', nocharacter)"
                :isNational="judegNational('remark')"
                v-model="list.remark"
                :readonly="disabled"
              >
              </mrc_ess_multiText>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getOrganizationalManagementList,
  detailOrganizationalManagement,
  addOrganizationalManagement,
  updateOrganizationalManagement,
  deleteOrganizationalManagement,
} from "@/service/api/OrganizationalManagement.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      list: {},
      btnIsLoading: false,
    };
  },
  computed: {
    // staffText: [this.$t('label_Former_boss') + '*', ''],
    // new_org_uuid () {
    //   return { prompt_name: 'org_levels_manager_filter_company', user_uuid: this.$store.state.userData.uuid }
    // },
    org_uuid() {
      return {
        prompt_name: "manager-sub-company",
        org_level_uuid: this.$store.state.currentCompany,
      };
      // return { prompt_name: 'org_levels_manager_filter_company', user_uuid: this.$store.state.userData.uuid }
    },
    deptuuid() {
      //部门参照查询字段
      if (this.$store.state.uuid) {
        return {
          prompt_name: "dept-change-update-or-check",
          dept_uuid: this.list.origin_dept_uuid,
          org_level_uuid: this.list.org_level_uuid,
        };
      } else {
        return {
          prompt_name: "dept-change",
          org_level_uuid: this.list.org_level_uuid,
        };
      }
      // return { prompt_name: 'dept-change', org_level_uuid: this.list.org_level_uuid }
    },
    company_uuid() {
      //当前选中公司
      return this.$store.state.currentCompany;
    },
    company_Name() {
      //当前选中公司名字
      const items = this.$store.state.topcompanylist.filter(
        (item) => item.uuid == this.$store.state.currentCompany
      );
      return items[0].org_level_name;
    },
    changeType() {
      //变更类型
      return { dict_name: "dept-change-type" };
    },
    spica() {
      //角色高级参照
      return { prompt_name: "level-role", org_level_uuid: this.company_uuid };
    },
    newdeptuuid() {
      //部门参照查询字段
      return {
        prompt_name: "new-dept-change",
        org_level_uuid: this.list.new_org_level_uuid,
        dept_uuid: this.list.origin_dept_uuid,
      };
      // return { prompt_name: 'levelUuid_deptUuid', org_level_uuid: this.list.new_org_level_uuid }
    },
    newjob_post_uuid() {
      //岗位查询
      return {
        prompt_name: "level-dept-post",
        dept_uuid: this.list.new_dept_uuid,
      };
    },
    newsuperior() {
      //上司高级参照
      // return { prompt_name: 'new_boss', org_level_uuid: this.list.new_org_level_uuid }
      return {
        prompt_name: "new-dept-boss",
        dept_uuid1: this.list.origin_dept_uuid,
        dept_uuid2: this.list.new_dept_uuid,
      };
    },
    newspica() {
      //角色高级参照
      return {
        prompt_name: "level-role",
        org_level_uuid: this.list.new_org_level_uuid,
      };
    },
    newmrbase_sys_job_post_grades() {
      //岗位等级
      return {
        prompt_name: "mrbase_sys_job_post_grades",
        job_post_uuid: this.list.transfer_job_post_uuid,
      };
    },
  },
  created() {},
  watch: {
    // 'list.change_status_uuid' (v) {
    //   if (v == 1) {
    //     this.list.new_org_level_uuid = ''
    //     this.list.new_dept_uuid = ''
    //     this.list.dept_principal_uuid = ''
    //     this.list.transfer_job_post_uuid = ''
    //   }
    // }
  },
  async mounted() {
    this.national("mrbase_sys_staffs_change_cont");
    if (this.$store.state.uuid) {
      this.getDetail();
    } else {
    }
  },
  methods: {
    getData(val) {},
    paramsChange() {},
    changeList(val) {
      // console.log(val);
      if (val.role_uuids) {
        val.role_uuids =
          String(val.role_uuids).indexOf(",") != -1
            ? String(val.role_uuids).split(",")
            : [val.role_uuids];
      }
      this.list = val;
    },
    async getDetail() {
      this.loading = true;
      const res = await detailOrganizationalManagement({
        uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        this.list = res.data;
        // console.log(this.list);
        // this.list.transferred_role_uuid = String(this.list.transferred_role_uuid).indexOf(',') != -1 ? this.list.transferred_role_uuid.split(',') : [this.list.transferred_role_uuid]
        this.list.transferred_post_grade =
          String(this.list.transferred_post_grade).indexOf(",") != -1
            ? this.list.transferred_post_grade.split(",")
            : [this.list.transferred_post_grade];
        this.list.change_status_uuid = String(this.list.change_status_uuid);
        // console.log(this.list);
      } else {
      }
      this.loading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.btnIsLoading = true;
      let list = this.$clone(this.list);
      delete list.result_status;
      String(list.change_effective).indexOf("-") == -1
        ? (list.change_effective = this.$moment(list.change_effective))
        : "";
      // list.transferred_role_uuid ? list.transferred_role_uuid = list.transferred_role_uuid.join() : ''
      list.transferred_post_grade
        ? (list.transferred_post_grade = list.transferred_post_grade.join())
        : "";
      // console.log(list);
      // return
      if (list.change_status_uuid == 1) {
        list.new_org_level_uuid = "";
        list.new_dept_uuid = "";
        list.dept_principal_uuid = "";
        list.transfer_job_post_uuid = "";
      }
      if (list.change_status_uuid != 2) {
        list.dept_principal_uuid = "";
      }
      if (this.$store.state.uuid) {
        const res = await updateOrganizationalManagement(
          this.$deletefield(null, list)
        );
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          await this.$emit("changeReadonly");
          this.getDetail();
        }
        this.btnIsLoading = false;
      } else {
        const res = await addOrganizationalManagement({
          ...list,
          result_status: 0,
        });
        if (res.code == 200) {
          this.$Message({ text: this.$t("message_added_successfully") });
          this.$router.push({ name: "organizationalManagement" });
        }
        this.btnIsLoading = false;
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "organizationalManagement",
            });
          })
          .catch((err) => {});
      }
    },
    vuetifyrequired(val) {
      if (val) {
        return true;
      } else {
        return false;
      }
    },
  },
  validations: {
    list: {
      org_level_uuid: {
        required,
      },
      origin_dept_uuid: {
        required,
      },
      change_status_uuid: {
        required,
      },
      change_effective: {
        required,
      },
      new_org_level_uuid: {
        typeRequired(value) {
          if (this.list.change_status_uuid == 1) {
            return true;
          } else {
            return this.vuetifyrequired(value);
          }
        },
      },
      new_dept_uuid: {
        typeRequired(value) {
          if (
            this.list.change_status_uuid == 1 ||
            this.list.change_status_uuid == 3
          ) {
            return true;
          } else {
            return this.vuetifyrequired(value);
          }
        },
      },
      dept_principal_uuid: {
        typeRequired(value) {
          if (
            this.list.change_status_uuid == 1 ||
            this.list.change_status_uuid == 3
          ) {
            return true;
          } else {
            return this.vuetifyrequired(value);
          }
        },
      },
      transfer_job_post_uuid: {
        // typeRequired (value) {
        //   if (this.list.change_status_uuid == 1) {
        //     return true
        //   }
        //   else {
        //     return this.vuetifyrequired(value)
        //   }
        // }
      },
      remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
    },
  },
};
</script>

<style scoped></style>
